<script setup>
import { ref, watch, computed, onMounted } from 'vue';

import dateFn from '@/mixins/date'

import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/vue/24/outline'

// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
// register Swiper custom elements
register();

import {useConfig} from '@/stores/config'
const configStore = useConfig();

import {useBooking} from '@/stores/booking'
const bookingStore = useBooking();


const today = new Date();
const last_day_of_month = computed(_=> new Date(bookingStore.year, bookingStore.month, 0).getDate());

const previous_month_date = computed(_=> {
  var tmp = new Date(bookingStore.year, bookingStore.month-1, 0);
  tmp.setMonth(bookingStore.month - 2);
  return tmp;
});
const next_month_date = computed(_=> {
  var tmp = new Date(bookingStore.year, bookingStore.month, 1);
  tmp.setMonth(bookingStore.month);
  return tmp;
});

const calendar_days = computed(_ => {
  const _calendar_days = [];

  var i = 1;
  if(bookingStore.year == today.getFullYear() && bookingStore.month == today.getMonth()+1) i = today.getDate();
  for(i; i <= last_day_of_month.value; i++){

    var this_day = new Date(bookingStore.year, bookingStore.month -1, i);

    _calendar_days.push({
      is_today : bookingStore.year == today.getFullYear() && bookingStore.month == today.getMonth()+1 && i == today.getDate(),
      is_disabled : bookingStore.year < today.getFullYear() || (bookingStore.year == today.getFullYear() && bookingStore.month < today.getMonth()) || (bookingStore.year == today.getFullYear() && bookingStore.month == today.getMonth() && i < today.getDate()),
      is_closed : configStore.config.closed_days.indexOf(bookingStore.year+'-'+(bookingStore.month < 10 ? '0'+bookingStore.month : bookingStore.month)+'-'+(i < 10 ? '0'+i : i)) != -1,
      day : i,
      day_formatted :  i < 10 ? '0'+i : i,
      day_of_week : dateFn.get_day_name(dateFn.get_week_day_from_date(this_day)),
      day_of_week_letter : dateFn.get_day_letter(dateFn.get_week_day_from_date(this_day))
    })
  }

  return _calendar_days;
})

function scroll_to_current_day(){
  const swiperEl = document.querySelector('swiper-container');
  swiperEl.swiper.slideTo(calendar_days.value.findIndex(d => d.day == bookingStore.day) - 3);
}

onMounted(scroll_to_current_day)
</script>

<template>
  <div class="flex space-x-3 text-lg items-center justify-center mb-4 md:text-gray-500">
    <ChevronLeftIcon 
      v-if="bookingStore.month > today.getMonth()+1 || bookingStore.year > today.getFullYear()"
      @click="bookingStore.date_object = previous_month_date"
      class="w-5 h-5 cursor-pointer"
      />
    <div>{{ dateFn.get_month_name(bookingStore.month-1) }} {{ bookingStore.year }}</div>
    <ChevronRightIcon 
      class="w-5 h-5 cursor-pointer" 
      @click="bookingStore.date_object = next_month_date"/>
  </div>

  <swiper-container
    slides-per-view="7"
    freeMode
    >


    <swiper-slide
      v-for="d of calendar_days"
      :class="[
        'flex flex-col items-center',
        d.is_disabled ? 'opacity-50' : '',
        d.is_closed ? 'opacity-50' : ''
      ]"
      @click="bookingStore.day = d.day; scroll_to_current_day()"
      >
      <div 
        :class="[
          d.day == bookingStore.day ? 'bg-active text-active' : '',
          'rounded-full w-8 h-8 flex items-center justify-center text-sm',
          d.is_today && d.day != bookingStore.day ? 'ring-2 ring-white/50 md:ring-0 md:bg-primary md:text-white' : 'bg-black/30 text-white/80 md:bg-white md:text-gray-500',
        ]"
        >{{ d.day_formatted }}
      </div>
      <div class="text-xs text-white/80 md:text-gray-500 mt-2">{{ d.day_of_week_letter }}</div>
    </swiper-slide>

  </swiper-container>
</template>